<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label">
        <label class="label">{{ $t("download.range") }}</label>
      </div>
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <label class="radio">
              <input
                type="radio"
                v-model="isAll"
                value="all"
                @click="clickAll"
              />
              {{ $t("download.all") }}
            </label>
            <label class="radio">
              <input type="radio" v-model="isAll" value="date" />
              {{ $t("download.dateform") }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{ $t("download.start") }}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <input
            class="input"
            type="date"
            style="max-width:400px"
            :disabled="isAll == 'all'"
            v-model="startDate"
            @Change="changeDate"
          />
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{ $t("download.end") }}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <input
            class="input"
            type="date"
            style="max-width:400px"
            :disabled="isAll == 'all'"
            v-model="endDate"
          />
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label"></div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <button
              class="button is-primary"
              v-bind:class="{ 'is-loading': isLoad }"
              @click="download"
            >
              {{ $t("download.button") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="errorMerssage" class="notification is-light is-danger">
      {{ errorMerssage }}
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

export default {
  props: {
    tenantId: {
      type: String,
      require: false,
      defalut: "aaa",
    },
    projectId: {
      type: String,
      require: false,
      defalut: "aaa",
    },
  },
  setup(props) {
    const { t } = useI18n();
    const isAll = ref("all");
    const isLoad = ref(false);
    const startDate = ref("");
    const endDate = ref("");
    const errorMerssage = ref("");

    const download = async () => {
      isLoad.value = true;
      errorMerssage.value = "";
      let date1 = new Date(startDate.value);
      let date2 = new Date(endDate.value);
      if (isAll.value == "all" || date1 <= date2) {
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          start: startDate.value,
          end: endDate.value,
        };
        try {
          await imsr.csvDownload("/events/csv", params, props.projectId);
        } catch (e) {
          errorMerssage.value = t("download.errorDownload");
        }
      } else {
        errorMerssage.value = t("download.errorDate");
      }
      isLoad.value = false;
    };

    const clickAll = () => {
      startDate.value = "";
      endDate.value = "";
    };

    const changeDate = () => {
      if (endDate.value == "") {
        endDate.value = startDate.value;
      }
    };

    return {
      isAll,
      isLoad,
      startDate,
      endDate,
      errorMerssage,
      download,
      clickAll,
      changeDate,
    };
  },
};
</script>
